module.exports = __webpack_public_path__ + "static/media/icn-logement-perso.ddffab7a.png";